module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    attrs: {
      "aria-label": "ix",
      "id": "pg_ix",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Who shot him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi1"
  }, [_vm._v("“Somebody with a gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("—")]), _vm._v("DASHIELL HAMMETT, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("RED HARVEST")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi1"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi1"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi1"
  }, [_vm._v("“Remember, children, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("crime does not pay")]), _vm._v(". Not like it used to.”")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—JOE E. LEWIS, COMEDIAN")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0